import { DecimalPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { SelectionScaleService } from '@core/services/selection-scale.service'
import { SelectionToolService } from '@core/services/selection-tool.service'
import { NumberFormatPipe } from '@shared/pipes/number-format.pipe'

@Component({
  selector: 'app-info-box',
  templateUrl: './info-box.component.html',
  styleUrl: './info-box.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    // Pipes
    NumberFormatPipe,
    DecimalPipe,

    // Material
    MatIconModule,
  ],
})
export class InfoBoxComponent {
  selectionToolService = inject(SelectionToolService)
  selectionScaleService = inject(SelectionScaleService)
}
